import React from "react";
import HeaderComponent from "../../components/header_component";
import Layout from "../../components/layout";
import NavBar from "../../components/nav_bar_component";

const AboutUsPage = () => {
  return (
    <div>
      <h1>About Us</h1>
    </div>
  );
};

export default AboutUsPage;
